import { render, staticRenderFns } from "./informationBox.vue?vue&type=template&id=4c6c4153&scoped=true&"
import script from "./informationBox.vue?vue&type=script&lang=js&"
export * from "./informationBox.vue?vue&type=script&lang=js&"
import style0 from "./informationBox.vue?vue&type=style&index=0&id=4c6c4153&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6c4153",
  null
  
)

export default component.exports